export default __webpack_public_path__ + "static/media/photo.f5ff6d72.png";